/** Hook to access TaskUIContext with built-in provider validation. */
// @ts-check
import { useContext } from 'react';
import { TaskUIContext } from './TaskUIContextDef.js';

/**
 * @returns {object} The TaskUIContext value.
 */
export const useTaskUI = () => {
  const context = useContext(TaskUIContext);
  if (!context) {
    throw new Error('useTaskUI must be used within a TaskUIProvider');
  }
  return context;
};
